export const enum TIPO_ERROR {
  ERROR = 'ERROR',
  INFO = 'INFO',
  SUCCESS = 'SUCCESS',
  WARNING = 'WARN'
}

export enum CODIGOS_ERROR {
  SIN_PREGUNTAS_SEG = 'BFRNE_018',
  CLIENTE_BLOQUEADO_24H = 'BFRNE_019',
  DESAFIO_PREGUNTAS_PREGUNTAS_INCORRECTAS = 'BFRNE_020',
  SECURE_CONTACT_USED = 'BFRNE_022',
  PIN_INVALIDO = 'BFRNE_023',
  ERROR_GENERAL = 'BFDEF_001',
  ERRORES_TOKEN = 'BFSEC',
  ERRORES_SERVICIO = 'BFTAU',
  CONNECTION_API_DOCUMENTS = 'BFTDO_001',
  INTERNAL_SERVER_API_DOCUMENTS = 'BFTDO_002',
  PREVIRED = 'BFRNE_015',
  INTERNAL = 'INTERNAL',
  BROWSER_NOT_SUPPORTED_IOS = 'ios-browser-not-supported',
  BROWSER_NOT_SUPPORTED = 'browser-not-supported',
  MAX_INTENTOS = 'max-intentos',
  ERROR_PREGUNTAS = 'error-preguntas',
  INTERMITENCIA = 'intermitencia',
  CLIENTE_EXISTE = 'cliente-existe'
}

const txtVolver = { txtBoton: 'VOLVER AL HOME' };
const txtCliente = { txtBoton: 'INGRESAR COMO CLIENTE' };
const txtContinuarInvitado = { txtBoton: 'CONTINUAR COMO INVITADO' };

export const ERRORES = {
  [CODIGOS_ERROR.INTERNAL]: {
    mensaje:
      'Hubo error al intentar conectar a nuestro servidor. Inténtalo más tarde',
    tipo: TIPO_ERROR.ERROR,
    titulo: 'Lo sentimos',
    ...txtVolver
  },
  [CODIGOS_ERROR.BROWSER_NOT_SUPPORTED_IOS]: {
    mensaje:
      'Al utilizar el sistema IOS, te recomendamos usar el navegador Safari para tener una mejor experiencia.',
    tipo: TIPO_ERROR.INFO,
    titulo: 'Ups!',
    ...txtVolver
  },
  [CODIGOS_ERROR.BROWSER_NOT_SUPPORTED]: {
    mensaje:
      'Al utilizar el sistema Android, te recomendamos usar los navegadores Google Chrome, Firefox u Opera para tener una mejor experiencia.',
    tipo: 'ERROR',
    titulo: 'Ups!',
    ...txtVolver
  },
  [CODIGOS_ERROR.MAX_INTENTOS]: {
    mensaje:
      'Has agotado el número de intentos de validación de datos. Vuelve a intentarlo en 24 horas contadas desde este momento.',
    tipo: TIPO_ERROR.WARNING,
    titulo: 'Has agotado el número de intentos.',
    ...txtVolver
  },
  [CODIGOS_ERROR.ERROR_PREGUNTAS]: {
    mensaje:
      'Intenta nuevamente. Al cuarto intento, se bloqueará por 24 horas.',
    tipo: TIPO_ERROR.WARNING,
    titulo: 'Al menos una de las respuestas ingresadas no es correcta',
    ...txtVolver
  },
  [CODIGOS_ERROR.INTERMITENCIA]: {
    mensaje:
      'El servicio presenta intermitencias. Por favor, intenta nuevamente.',
    tipo: TIPO_ERROR.WARNING,
    titulo: 'El servicio presenta intermitencias.',
    ...txtVolver
  },
  [CODIGOS_ERROR.CLIENTE_EXISTE]: {
    mensaje:
      'Puedes completar tu Estado de Situación desde Banco en Línea con tu clave haciendo click en el botón "Ingresar como cliente". <br> ' +
      '<br>' +
      'Si olvidaste o no posees clave web, continúa como invitado (para esta opción debes contar con cédula de identidad vigente).',
    tipo: TIPO_ERROR.WARNING,
    titulo: 'Según nuestros registros ya eres cliente.',
    ...txtContinuarInvitado,
    ...txtCliente
  }
};
